import { locationActions } from "../../actionTypes";

const initialState = {
	location: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case locationActions.UPDATE_LOCATION: {
			return { ...state, ...initialState };
		}

		case locationActions.UPDATE_LOCATION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				location: action.payload,
			};
		}

		case locationActions.UPDATE_LOCATION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
